<template>
    <div>
        <b-form-group v-if="jenisPinjaman.id != 13 && jenisPinjaman.id != 14">
            <b-table bordered hover show-empty :fields="fields" :busy="isBusy" :items="tipeBarang" responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data.
                </template>
                <template v-slot:cell(spekId)="row">
                    <div v-if="row.item.spekId == 2">Harga RESMI</div>
                    <div v-if="row.item.spekId == 5">Harga LN</div>
                    <div v-if="row.item.spekId == 3">Harga RR</div>
                </template>
                <template v-slot:cell(harga)="row">
                    Rp. {{ $helper.addThousandSeparator(row.item.harga) }} <b-button size="sm" class="table-button edit"
                        v-b-tooltip.hover title="Edit" name="tipeBarangEditBtn" @click="editHarga(row.item)">
                        <i class="fa fa-pencil-square-o"></i>
                    </b-button>

                </template>
                <template v-slot:cell(approval)="row">
                    <b-badge variant="success" v-if="row.item.canApprove">YA</b-badge>
                    <b-badge variant="danger" v-else>TIDAK</b-badge>
                </template>
                <template v-slot:cell(aksi)="row">
                    <b-button :disabled="isSubmitting" variant="pgiBtn" class="mx-2" @click="openHistory(row.item)">
                        <i class="fa fa-history" v-b-tooltip.hover title="History"></i>
                    </b-button>
                    <b-button v-if="!row.item.canApprove" :disabled="isSubmitting" variant="pgiBtn"
                        @click="switchCanApprove(row.item)">
                        <i class="fa fa-power-off" v-b-tooltip.hover title="Aktivasi Approval SM"></i>
                    </b-button>
                </template>
            </b-table>
        </b-form-group>

        <b-tabs v-else class="tab-wrapper" content-class="tab-content-wrapper">
            <b-tab title="Aktif">
                <div v-if="jenisPinjaman.id == 13 || jenisPinjaman.id == 14">
                    <b-button variant="pgiBtn" class="mb-2" name="hargaTahunAddBtn" @click="addHargaTahun"><i
                            class="fa fa-plus mr-2"></i>Entri Baru</b-button>

                    <b-table bordered hover show-empty :fields="fieldsHargaTahunKendaraan" :busy="isBusy"
                        :items="input.hargaTahun" responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data.
                        </template>
                        <template v-slot:cell(hargaBpkb)="row">
                            Rp. {{ $helper.addThousandSeparator(row.item.hargaBpkb) }} <b-button size="sm"
                                class="table-button edit" v-b-tooltip.hover title="Edit" name="tipeBarangEditBtn"
                                @click="editHargaTahunKendaraan(1, row.item)">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </template>
                        <template v-slot:cell(hargaKendaraan)="row">
                            Rp. {{ $helper.addThousandSeparator(row.item.hargaKendaraan) }} <b-button size="sm"
                                class="table-button edit" v-b-tooltip.hover title="Edit" name="tipeBarangEditBtn"
                                @click="editHargaTahunKendaraan(2, row.item)">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </template>
                        <template v-slot:cell(isActive)="row">
                            <b-badge variant="success" v-if="row.item.isActive">Aktif</b-badge>
                            <b-badge variant="danger" v-else>Non - Aktif</b-badge>
                        </template>
                        <template v-slot:cell(aksi)="row">
                            <b-button variant="pgiBtn" @click="switchStatusHargaTahun(row.item)">
                                <i class="fa fa-power-off" v-b-tooltip.hover title="Aktivasi Approval SM"></i>
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </b-tab>
            <b-tab title="Non Aktif">
                <b-table v-if="jenisPinjaman.id == 13 || jenisPinjaman.id == 14" bordered hover show-empty
                    :fields="fieldsHargaTahunKendaraan" :busy="isBusy" :items="hargaTahunNonAktif" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data.
                    </template>
                    <template v-slot:cell(hargaBpkb)="row">
                        Rp. {{ $helper.addThousandSeparator(row.item.hargaBpkb) }} <b-button size="sm"
                            class="table-button edit" v-b-tooltip.hover title="Edit" name="tipeBarangEditBtn"
                            @click="editHargaTahunKendaraan(1, row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                    </template>
                    <template v-slot:cell(hargaKendaraan)="row">
                        Rp. {{ $helper.addThousandSeparator(row.item.hargaKendaraan) }} <b-button size="sm"
                            class="table-button edit" v-b-tooltip.hover title="Edit" name="tipeBarangEditBtn"
                            @click="editHargaTahunKendaraan(2, row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                    </template>
                    <template v-slot:cell(isActive)="row">
                        <b-badge variant="success" v-if="row.item.isActive">Aktif</b-badge>
                        <b-badge variant="danger" v-else>Non - Aktif</b-badge>
                    </template>
                    <template v-slot:cell(aksi)="row">
                        <b-button variant="pgiBtn" @click="switchStatusHargaTahun(row.item)">
                            <i class="fa fa-power-off" v-b-tooltip.hover title="Aktivasi Approval SM"></i>
                        </b-button>
                    </template>
                </b-table>
            </b-tab>
        </b-tabs>

        <b-modal id="modal-harga" size="md" title="Harga">
            <b-input-group prepend="Rp.">
                <b-form-input v-model="input.harga" name="harga" required></b-form-input>
            </b-input-group>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="updateHargaBtn" type="button" :disabled="isSubmitting"
                    @click="onSubmitHarga()" form="updateHargaForm">
                    {{ isSubmitting ? 'Loading...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-edit-harga-tahun-kendaraan" size="md" title="Harga">
            <b-input-group prepend="Rp.">
                <b-form-input v-model="input.harga" name="harga" required></b-form-input>
            </b-input-group>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="updateHargaBtn" type="button" :disabled="isSubmitting"
                    @click="onSubmitHargaTahun()" form="updateHargaForm">
                    {{ isSubmitting ? 'Loading...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-entri-harga-tahun-kendaraan" size="md" title="Entri Harga Baru">

            <label>Tahun</label>
            <b-input-group class="mb-3">
                <b-form-input v-model="input.tahun" name="tahun" required></b-form-input>
            </b-input-group>
            <label>Harga BPKB</label>
            <b-input-group class="mb-3" prepend="Rp.">
                <b-form-input v-model="input.hargaBpkb" name="hargaBpkb" required></b-form-input>
            </b-input-group>
            <label>Harga Kendaraan</label>
            <b-input-group class="mb-3" prepend="Rp.">
                <b-form-input v-model="input.hargaKendaraan" name="hargaKendaraan" required></b-form-input>
            </b-input-group>

            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="updateHargaBtn" type="button" :disabled="isSubmitting"
                    @click="confirmEntriHargaBaru()" form="updateHargaForm">
                    {{ isSubmitting ? 'Loading...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-history" size="md" :title="'History ' + history.tipeBarang + ' ' + history.spekId">
            <div v-if="isSubmitting">
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Loading data...</strong>
                </div>
            </div>
            <div v-else>
                <div v-for="(item, index) of history.history" :key="index" class="my-2">
                    <div>Tanggal : {{ $helper.changeDateTimeFormat(item.createdAt) }}</div>
                    <div>Dibuat oleh : {{ item.createdBy }}</div>
                    <div>Harga sesudah : Rp. {{ $helper.addThousandSeparator(item.priceAfter) }}</div>
                    <div>Harga sebelum : Rp. {{ $helper.addThousandSeparator(item.priceBefore) }}</div>
                    <hr>
                </div>
            </div>

            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" :disabled="isSubmitting" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <ModalConfirm id="m-confirm-canApproveSM" title="Konfirmasi Ubah Status Approval SM" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk mengubah Status Approval SM ini?" @submit="onSubmitCanApprove" />
        <ModalConfirm id="m-confirm-switch-status-harga-tahun" title="Konfirmasi Ubah Status Harga Tahun"
            :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah Status Harga Tahun ini?"
            @submit="onSubmitSwitchStatusHargaTahun" />
        <ModalConfirm id="modal-confirm-entri-harga-tahun-kendaraan" title="Konfirmasi Entri Harga Tahun"
            :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menambah Harga Tahun ini?"
            @submit="onSubmitEntriHargaTahun" />
    </div>
</template>
<script>
import HargaTahun from '../../../components/hargatahun/HargaTahun'
import HargaTahunNonAktif from '../../../components/hargatahun/HargaTahunNonAktif'
export default {
    props: {
        rincian: {
            type: Array,
            required: true
        },
        idTipe: {
            type: Number,
            default: null
        },
        jenisPinjaman: {
            type: Object,
            default: null
        }
    },
    components: {
        HargaTahun,
        HargaTahunNonAktif,
    },
    data() {
        return {
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,
            input: {
                harga: null,
                tahun: null,
                hargaBpkb: null,
                hargaKendaraan: null,
                spekId: null,
                hargaTahun: [],
                nonAktifHargaTahun: [],
                canApprove: null
            },

            tipeBarang: null,
            activeId: null,

            fields: [
                { key: "spekId", label: "Spek" },
                { key: "harga", label: "Harga" },
                { key: "approval", label: "Approval SM" },
                { key: "aksi", label: "Aksi" }
            ],

            fieldsHargaTahunKendaraan: [
                { key: "tahun", label: "Tahun" },
                { key: "hargaBpkb", label: "Harga BPKB" },
                { key: "hargaKendaraan", label: "Harga Kendaraan" },
                { key: "isActive", label: "Status" },
                { key: "aksi", label: "Aksi" }
            ],

            hargaSesuaiTahun: false,


            indexHargaTahun: 2,
            isKendaraan: false,
            disabled: false,
            deleteHargaTahun: [],
            hargaTahunNonAktif: [],
            modalConfirmNonAktif: {},
            modalConfirmAktif: {},
            modalConfirmRemove: {},

            harga: [
                { spek: 'RESMI', harga: 10000, approval: true },
                { spek: 'LN', harga: 1000, approval: false },
                { spek: 'RR', harga: 5000, approval: true }
            ],

            history: {
                spekId: null,
                tipeBarang: '',
                history: []
            }
        }
    },
    methods: {
        init() {
            this.initStatus = 0
            this.id = (this.idTipe != null) ? this.idTipe : this.$route.params.id

            let url = ''
            if (this.jenisPinjaman.id == 13 || this.jenisPinjaman.id == 14) {
                url = `barang-tipe-v2/${this.id}`
            } else {
                url = `barang-tipe-v2/prices/${this.id}`
            }
            let getHarga = this.$axios.get(url).then(response => {
                this.tipeBarang = response.data
                this.harga = response.data.harga
                this.hargaSesuaiTahun = response.data.hasTahun

                if (this.jenisPinjaman.name == 'Kendaraan') {
                    this.fieldHarga = this.fieldHargaKendaraan
                } else if (this.jenisPinjaman.name == 'Elektronik') {
                    this.fieldHarga = this.fieldHargaElektronik
                }

                else this.toggleBusy()

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getHarga]).then(() => {
                this.initStatus = 1
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })

        },
        fetchData() {
            this.toggleBusy()
            this.hargaSesuaiTahun = false

            let url = ''
            if (this.jenisPinjaman.id == 13 || this.jenisPinjaman.id == 14) {
                url = `barang-tipe-v2/${this.id}`
            } else {
                url = `barang-tipe-v2/prices/${this.id}`
            }
            this.$axios.get(url).then(response => {
                this.tipeBarang = response.data
                this.harga = response.data.harga
                this.hargaSesuaiTahun = response.data.hasTahun

                if (this.jenisPinjaman.name == 'Kendaraan') {
                    this.fieldHarga = this.fieldHargaKendaraan
                } else if (this.jenisPinjaman.name == 'Elektronik') {
                    this.fieldHarga = this.fieldHargaElektronik
                }

                else this.toggleBusy()

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            }).catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        addHargaTahun() {
            this.input.tahun = null
            this.input.hargaBpkb = null
            this.input.hargaKendaraan = null
            this.$bvModal.show("modal-entri-harga-tahun-kendaraan")
        },

        confirmEntriHargaBaru() {
            if (this.$helper.isNullOrEmpty(this.input.tahun)) {
                return this.$helper.toastErr(this, "Mohon Isi Tahun!")
            }
            if (this.$helper.isNullOrEmpty(this.input.hargaBpkb)) {
                return this.$helper.toastErr(this, "Mohon Isi Harga!")
            }
            if (this.$helper.isNullOrEmpty(this.input.hargaKendaraan)) {
                return this.$helper.toastErr(this, "Mohon Isi Harga!")
            }
            this.$bvModal.show("modal-confirm-entri-harga-tahun-kendaraan")
        },

        onSubmitEntriHargaTahun() {
            this.isSubmitting = true
            let json = {
                "tipeBarangId": this.id,
                "tahun": this.input.tahun,
                "hargaBpkb": this.$helper.removeThousandSeparator(this.input.hargaBpkb),
                "hargaKendaraan": this.$helper.removeThousandSeparator(this.input.hargaKendaraan),
                "isActive": true
            }

            this.$axios.post(`barang-tipe-v2/insert-update-price-year`, json).then(() => {
                this.$bvModal.hide("modal-entri-harga-tahun-kendaraan")
                this.$bvModal.hide("modal-confirm-entri-harga-tahun-kendaraan")
                this.fetchData()
                this.isSubmitting = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },

        removeHargaTahun(index) {
            this.input.hargaTahun = this.input.hargaTahun.filter(item => item.index != index)
        },

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        editHarga(item) {
            this.input.harga = item.harga.toString()
            this.input.spekId = item.spekId
            this.input.canApprove = item.canApprove
            this.$bvModal.show("modal-harga")
        },

        editHargaTahunKendaraan(model, item) {
            this.activeId = item
            this.activeId.model = model
            if (model == 1) {
                this.input.harga = item.hargaBpkb.toString()
            }
            if (model == 2) {
                this.input.harga = item.hargaKendaraan.toString()
            }
            this.$bvModal.show("modal-edit-harga-tahun-kendaraan")
        },

        onSubmitHarga() {
            if (this.$helper.isNullOrEmpty(this.input.harga)) {
                return this.$helper.toastErr(this, "Mohon Isi Harga!")
            }

            let json = {
                "spekId": this.input.spekId,
                "tipeId": this.id,
                "price": this.$helper.removeThousandSeparator(this.input.harga),
                "canApprove": this.input.canApprove
            }
            this.isSubmitting = true
            this.$axios.post(`barang-tipe-v2/update-harga-spek`, json).then(() => {

                this.$bvModal.hide("modal-harga")
                this.fetchData()
                this.$emit('hasSubmit')
                this.isSubmitting = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },

        onSubmitHargaTahun() {
            if (this.$helper.isNullOrEmpty(this.input.harga)) {
                return this.$helper.toastErr(this, "Mohon Isi Harga!")
            }

            let json = {
                "id": this.activeId.id, // null bila insert
                "tipeBarangId": this.id,
                "tahun": this.activeId.tahun,
                "hargaBpkb": (this.activeId.model == 1) ? this.$helper.removeThousandSeparator(this.input.harga) : this.$helper.removeThousandSeparator(this.activeId.hargaBpkb),
                "hargaKendaraan": (this.activeId.model == 2) ? this.$helper.removeThousandSeparator(this.input.harga) : this.$helper.removeThousandSeparator(this.activeId.hargaKendaraan),
                "isActive": this.activeId.isActive
            }

            this.isSubmitting = true
            this.$axios.post(`barang-tipe-v2/insert-update-price-year`, json).then(() => {

                this.$bvModal.hide("modal-edit-harga-tahun-kendaraan")
                this.fetchData()
                this.isSubmitting = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },

        switchStatusHargaTahun(item) {
            this.activeId = item
            this.$bvModal.show("m-confirm-switch-status-harga-tahun")
        },

        onSubmitSwitchStatusHargaTahun() {
            let json = {
                "id": this.activeId.id, // null bila insert
                "tipeBarangId": this.id,
                "tahun": this.activeId.tahun,
                "hargaBpkb": this.$helper.removeThousandSeparator(this.activeId.hargaBpkb),
                "hargaKendaraan": this.$helper.removeThousandSeparator(this.activeId.hargaKendaraan),
                "isActive": !this.activeId.isActive
            }

            this.isSubmitting = true
            this.$axios.post(`barang-tipe-v2/insert-update-price-year`, json).then(() => {

                this.$bvModal.hide("m-confirm-switch-status-harga-tahun")
                this.fetchData()
                this.isSubmitting = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },

        switchCanApprove(item) {
            this.input.harga = item.harga.toString()
            this.input.spekId = item.spekId
            this.input.canApprove = item.canApprove
            this.$bvModal.show("m-confirm-canApproveSM")
        },

        onSubmitCanApprove() {
            this.isSubmitting = true
            let json = {
                "spekId": this.input.spekId,
                "tipeId": this.id,
                "price": this.$helper.removeThousandSeparator(this.input.harga),
                "canApprove": !this.input.canApprove
            }

            this.$axios.post(`barang-tipe-v2/update-harga-spek`, json).then(() => {

                this.$bvModal.hide("m-confirm-canApproveSM")
                this.fetchData()
                this.isSubmitting = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },

        openHistory(item) {
            this.isSubmitting = true
            this.$bvModal.show("modal-history")
            this.$axios.get(`barang-tipe-v2/price-history?typeId=${this.id}&specId=${item.spekId}`).then(response => {
                if (Array.isArray(this.rincian)) {
                    let idx = this.rincian.findIndex(item => item.id == this.id);
                    if (idx !== -1) {
                        this.history.tipeBarang = this.rincian[idx].name;
                    }
                } else {
                    this.history.tipeBarang = this.rincian.name;
                }
                this.history.spekId = (item.spekId == 2) && 'Harga Resmi' || (item.spekId == 5) && 'Harga LN' || (item.spekId == 3) && 'Harga RR'
                this.history.history = response.data

                this.fetchData()
                this.isSubmitting = false
            })
                .catch(error => {
                    console.log(error)
                    this.$bvModal.hide("modal-history")
                    // console.log(error.response.data.reason)
                    // this.$helper.parseError(this, error)
                    this.$helper.toastErr(this, 'Tidak ada history')
                    this.isSubmitting = false
                })
        }
    },
    watch: {

        //----------------- Pantau Filter Jenis Barang -----------------

        "input.harga": function (newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.harga = result);
        },

        "input.hargaBpkb": function (newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaBpkb = result);
        },

        "input.hargaKendaraan": function (newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaKendaraan = result);
        },

        "hargaSesuaiTahun": function (val) {
            if (val == true) {
                this.input.hargaTahun = []
                this.hargaTahunNonAktif = []

                let datas = this.tipeBarang.tahun
                for (var x of datas) {
                    if (x.isActive == true) {
                        //Elektronik
                        if (this.isKendaraan == false) {
                            this.input.hargaTahun.push(x)
                        }
                        //Kendaraan
                        if (this.isKendaraan == true) {
                            this.input.hargaTahun.push(x)
                        }
                    } else if (x.isActive == false) {
                        //Elektronik
                        if (this.isKendaraan == false) {

                            this.hargaTahunNonAktif.push(x)
                        }
                        //Kendaraan
                        if (this.isKendaraan == true) {
                            this.hargaTahunNonAktif.push(x)
                        }
                    }
                    this.indexHargaTahun++
                }

            }
        },

    },
    created() {
        this.init()
    }
}
</script>